import { useEffect } from 'react';
import { useContentEntityListItems } from '@wajeez-web/components/helpers';
import { ButtonHeadless, Modal, Spin } from '@wajeez-web/components/ui';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { getContentEntityListItems } from '@wajeez-web/stores/content';

interface ContentEntityListItemsModalProps {
  isOpen: boolean;
  onClose: () => void;
  id: number;
}

export const ContentEntityListItemsModal = ({
  isOpen,
  onClose,
  id,
}: ContentEntityListItemsModalProps) => {
  const items = useContentEntityListItems();

  useEffect(() => {
    getContentEntityListItems(id);
  }, [id]);

  const renderItems = () => {
    return items.data.map((d) => {
      return (
        <div
          className={`w-full py-4 px-3 rounded-md border break-all text-center flex justify-center items-center`}
        >
          {d.title}
        </div>
      );
    });
  };

  return (
    <Modal
      title="Content Entity List Items"
      open={isOpen}
      onClose={() => {
        onClose();
      }}
      fontClassName="font-[Tajawal]"
    >
      <div className="w-full">
        {items.status === 'loading' ? (
          <div className="w-full min-h-[300px] flex justify-center items-center">
            <Spin />
          </div>
        ) : (
          <div className="w-full min-h-[300px] max-h-[400px] mt-5 grid grid-cols-3 content-start items-stretch gap-x-4 gap-y-4 overflow-y-auto">
            {renderItems()}
          </div>
        )}
        <div className="mt-6 w-full flex justify-end items-center">
          <div className="w-[70px]">
            <ButtonHeadless
              paddingYStyle="py-2"
              action={() => {
                onClose();
              }}
            >
              <div className="text-white">
                <ReturnTranslatedText
                  origintext="Ok"
                  text={`buttons.${'Ok'}`}
                />
              </div>
            </ButtonHeadless>
          </div>
        </div>
      </div>
    </Modal>
  );
};
